import HttpRequest from "./HttpRequest"

const SubFormService = {
    getSubForms: async () => {
        return await HttpRequest.getWithSession('DocumentOnlyTemplateSubForms', { })
    },
}

export default SubFormService